import * as React from "react";
import Svg, { Rect, G, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={38}
      height={38}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Rect width={38} height={38} rx={8} fill="#F9F9F9" />
      <G fill="#333">
        <Path d="M25.08 14.679V7h-8.972l-1.298 3.717 2.186 1.39-5.511 6.252 1.139-6.76-2.554-.84L11.834 7H5v20.073h11.182c.018-.037.036-.067.055-.098l.337-.545 6.472-10.557c.447-.747 1.206-1.194 2.033-1.194zM26.072 16.51c-.245-.404-.619-.606-.992-.606-.367 0-.747.202-.992.606l-6.473 10.563-.336.545c-.607.986-.025 2.382.992 2.382h13.618c1.017 0 1.599-1.396.999-2.382L26.072 16.51zm-1.85 3.754a.86.86 0 011.721 0v3.533a.861.861 0 11-1.72 0v-3.533zm.858 7.966a1.011 1.011 0 11.002-2.022 1.011 1.011 0 01-.002 2.022z" />
      </G>
    </Svg>
  );
}

export default SvgComponent;
